import * as React from 'react'
import { FC, useCallback } from 'react'
import { getStyles } from './styling'
import { BillToSelectCardContents } from './BillToRadioCardContents/BillToRadioCardContents'
import { BillTo } from '@user/store/entityLocations'
import Card from '@mui/material/Card'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import { useTheme } from '@mui/material/styles'

export interface Props {
  checked?: boolean
  location: BillTo
  onClick: (locationId: string) => void
}

export const BillToRadioCard: FC<Props> = (props: Props) => {
  const { checked = false, location, onClick } = props

  const handleClick = useCallback(() => {
    onClick(location.id)
  }, [location.id, onClick])
  const styles = getStyles(props, useTheme())
  return (
    <>
      <Card sx={styles.card}>
        <FormControlLabel
          checked={checked}
          value={true}
          control={<Radio size="medium" />}
          label="Select Customer"
          labelPlacement="end"
          onClick={handleClick}
          style={{ marginLeft: 0 }}
        />
        <BillToSelectCardContents location={location} />
      </Card>
    </>
  )
}
BillToRadioCard.displayName = 'LocationSelectCard'
